import React,{useState, useContext} from 'react';

import {  
  Row,
  Col,
  Alert,
  Spinner
} from 'react-bootstrap';
import UserContext from './../../contexts/UserContext';
import {Uploader} from '../../components';
import Utils from '../../Utils';
import _ from 'lodash';

const FileForm = (props) => {

  const [scorm,setScorm] = useState('');  
  const [uploading,setUploading] = useState(false);
  const [errMsg,setErrMsg] = useState('');
  const {getPkgSize,getAvailableSize, userData, getMaxScormSize} = useContext(UserContext);
  
  const scormsize_in_mb = getMaxScormSize();//_.get(process.env,'REACT_APP_MAX_SCORM_SIZE',50);
  const filesize_in_mb =  _.get(process.env,'REACT_APP_MAX_PDF_PPT_SIZE',1);
  
  const manageFileSlides = (status, attr) => {
    const data = JSON.parse(attr);    
    var ary = (new Array(_.get(data,'sizeArr.length',0))).fill(1);
    ary = ary.map((a,idx) => { return {sid: idx+1,
                  fileStep: 'within', //fileStep : step level t which file uploaded
                                          //init : file uploaded at step2 /initial level
                                          //within : file uploaded at step3/within scorm levels
                  title:data.sizeArr[idx].path.substr(0, data.sizeArr[idx].path.length - 4), 
                  sname:data.sizeArr[idx].path, 
                  folder: data.fname, 
                  type: 'Photo',
                  size: data.sizeArr[idx].size}});
    props.onFinalize(ary,'File', 'upload');
  }

  const onUploadFile = (attr,status) => {         
    if(status==='error_file_size'){
      setErrMsg(`You have uploaded ${(attr.meta.size/1024/1024).toFixed(1)} MB file, however, 
      the acceptable maximum file size is ${filesize_in_mb} MB. Try again with an acceptable sized file.`);
      window.setTimeout(function(){
        setErrMsg('');
        setUploading('Please wait');
      }, 1000);
    }else{
        let file_size = (status.size/1024/1024).toFixed(1);
        let tot_size = parseInt(file_size) + getPkgSize();
        if(tot_size > scormsize_in_mb){
          setErrMsg(`Total SVASU size allowed is ${scormsize_in_mb} MB,You have used ${getPkgSize()} MB.`);
          return;
        }else{
          setErrMsg('');           
          manageFileSlides(status, attr);          
        }   
    }
  }

  const errEmpty = () =>{
    setErrMsg('');
  }

  const startUploading = (attr,status) => { 

    if(status=='rejected_file_type'){
      setUploading(false);
      window.alert("Invalid file type upload!\nPlease try again!");
    }else{
      setUploading('Please wait.. we are processing your file..');
    }    
  }


  const renderUploadPPT = () => {
    return <>   
    <div  className="uploadPPT">
    <Row>
      <Col lg={10} className="text-center">
      {errMsg !== ''  && <>
      <Alert variant="danger" className="p-3"><i className="fa fa-exclamation-circle" />  {errMsg} </Alert>
        </>}
        {(uploading && errMsg === '') && <Alert className="p-0 m-0"> {uploading}  <Spinner animation="border" variant="dark" /><br />        
        </Alert>}
        {!uploading && <>
          {(scorm === '' && errMsg ==='') && <>
            No file selected.
          </>}
          {scorm!=='' && <>            
            PPT/PDF file selected <span className="fa fa-arrow-up"/> <span className="fa fa-close clickable" title="Remove" onClick={() => onUploadFile('')} />
          </>}
        </>}  
      </Col> 
      {uploading===false && <Col lg={2} className="text-right"></Col>}
    </Row> 
      <div title="Select File">
        
        <Uploader 
        accept=".ppt,.pptx,.pdf" 
        instructions={`Click the icon or drag and drop the file to upload your PPT / PDF file. Max file size allowed is ${getAvailableSize(filesize_in_mb)} MB. Supported file formats are .ppt, .pptx, .pdf, and .png only.`}
        maxSizeBytes={getAvailableSize(filesize_in_mb)*1024*1024} 
        uploadUrl={Utils.apiUrl('processfile')} 
        onUpload={onUploadFile} 
        onSubmit={startUploading}
        onClick={errEmpty} />
      </div>
      </div>
    </>;
  }
  
  return <Row className="uploadImageVideopage">    
    <Col className="mt-3">{renderUploadPPT()}</Col>
  </Row>;
}

export default FileForm;